import { Transition } from '@uirouter/angular';

export function buttonVoucherRedirectTo(trans: Transition) {
  const params = {...trans.params()};

  return {
    state: 'main.checkout.index',
    params: {
      code: params.code
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/buttons/redirects/voucher.redirect.ts